import { Route } from 'react-router';
import { importOrReload } from '@/utils/route.utils';

export const adminRoutes = (
  <Route
    path="admin"
    lazy={importOrReload(() => import('@/pages/support/admin/layout'))}
  >
    <Route
      path="orgs-management"
      lazy={importOrReload(
        () => import('@/pages/support/admin/orgs-management/page')
      )}
    >
      <Route
        path="add"
        lazy={importOrReload(
          () => import('@/pages/support/admin/orgs-management/add/page')
        )}
      />
      <Route
        path=":orgManId/:orgManCountryId"
        lazy={importOrReload(
          () => import('@/pages/support/admin/orgs-management/[orgManId]/page')
        )}
      />
    </Route>
    <Route
      path="org-directory"
      lazy={importOrReload(
        () => import('@/pages/support/admin/org-directory/page')
      )}
    >
      <Route
        path="add"
        lazy={importOrReload(
          () => import('@/pages/support/admin/org-directory/add/page')
        )}
      />
      <Route
        path=":orgDirId"
        lazy={importOrReload(
          () => import('@/pages/support/admin/org-directory/[orgDirId]/page')
        )}
      />
    </Route>
    <Route
      path="countries"
      lazy={importOrReload(
        () => import('@/pages/support/admin/countries/page')
      )}
    >
      <Route
        path="add-country"
        lazy={importOrReload(
          () => import('@/pages/support/admin/countries/add-country/page')
        )}
      />
      <Route
        path=":countryId"
        lazy={importOrReload(
          () => import('@/pages/support/admin/countries/[countryId]/page')
        )}
      />
    </Route>
    <Route
      path="products"
      lazy={importOrReload(() => import('@/pages/support/admin/products/page'))}
    >
      <Route
        path="manage-categories"
        lazy={importOrReload(
          () => import('@/pages/support/admin/products/manage-categories/page')
        )}
      />
      <Route
        path="add"
        lazy={importOrReload(
          () => import('@/pages/support/admin/products/add/page')
        )}
      />
      <Route
        path=":productId"
        lazy={importOrReload(
          () => import('@/pages/support/admin/products/[productId]/page')
        )}
      />
    </Route>
    <Route
      path="support-users"
      lazy={importOrReload(
        () => import('@/pages/support/admin/support-users/page')
      )}
    >
      <Route
        path=":supportUserId"
        lazy={importOrReload(
          () =>
            import('@/pages/support/admin/support-users/[supportUserId]/page')
        )}
      />
      <Route
        path="add"
        lazy={importOrReload(
          () => import('@/pages/support/admin/support-users/add/page')
        )}
      />
    </Route>
    <Route
      path="report-users"
      lazy={importOrReload(
        () => import('@/pages/support/admin/report-users/page')
      )}
    >
      <Route
        path=":reportUserId"
        lazy={importOrReload(
          () => import('@/pages/support/admin/report-users/[reportUserId]/page')
        )}
      />
      <Route
        path="add"
        lazy={importOrReload(
          () => import('@/pages/support/admin/report-users/add/page')
        )}
      />
    </Route>
    <Route
      path="site-managers"
      lazy={importOrReload(
        () => import('@/pages/support/admin/site-managers/page')
      )}
    >
      <Route
        path=":siteManagersId"
        lazy={importOrReload(
          () =>
            import('@/pages/support/admin/site-managers/[siteManagersId]/page')
        )}
      />
      <Route
        path="add"
        lazy={importOrReload(
          () => import('@/pages/support/admin/site-managers/add/page')
        )}
      />
    </Route>
    <Route
      path="reporting"
      lazy={importOrReload(
        () => import('@/pages/support/admin/reporting/page')
      )}
    >
      <Route
        path="new/:reportType"
        lazy={importOrReload(
          () => import('@/pages/support/admin/reporting/new/page')
        )}
      />
    </Route>
    <Route
      path="examiners"
      lazy={importOrReload(
        () => import('@/pages/support/admin/examiners/layout')
      )}
    >
      <Route
        path="profiles"
        lazy={importOrReload(
          () => import('@/pages/support/admin/examiners/profiles/page')
        )}
      >
        <Route
          path="add"
          lazy={importOrReload(
            () => import('@/pages/support/admin/examiners/profiles/add/page')
          )}
        />
        <Route
          path=":examinerProfileId"
          lazy={importOrReload(
            () =>
              import('@/pages/support/admin/examiners/profiles/[examinerProfileId]/page')
          )}
        />
      </Route>
    </Route>
  </Route>
);
